import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import UserList from "./UserList";
import UserListSA from "./UserListSA";
import IndividualSummary from "./IndividualSummary";
import ApartmentSummary from "./ApartmentSummary";
import CorporateSummary from "./CorporateSummary";
import PartnerSummary from "./PartnerSummary";
import CreateUser from "./CreateUser";
import PasswordUpdate from "./PasswordUpdate";
import PartnerSummarySA from "./PartnerSummarySA";
import IndividualSummarySA from "./IndividualSummarySA";
import ApartmentSummarySA from "./ApartmentSummarySA";
import CorporateSummarySA from "./CorporateSummarySA";
export default function User() {
  return (
    <Switch>
      <Redirect exact={true} from="/user" to="/user/user-list" />

      {/* Layout */}
      
      <Route path="/user/user-list" component={UserList} />
      <Route path="/user/sa-user-list" component={UserListSA} />
      <Route path="/user/sa-partner-user-list" component={PartnerSummarySA} />
      <Route path="/user/sa-apart-user-list" component={ApartmentSummarySA} />
      <Route path="/user/sa-indiv-user-list" component={IndividualSummarySA} />
      <Route path="/user/sa-corp-user-list" component={CorporateSummarySA} />
      <Route path="/user/indiv-list" component={IndividualSummary} />
      <Route path="/user/apart-list" component={ApartmentSummary} />
      <Route path="/user/corp-list" component={CorporateSummary} />
      <Route path="/user/partner-list" component={PartnerSummary} />
      <Route path="/user/user-create" component={CreateUser} />
      <Route path="/user/password-update" component={PasswordUpdate} />
    </Switch>
  );
}
